import { render } from "./LastTransaction.vue?vue&type=template&id=1fe85b16&scoped=true"
import script from "./LastTransaction.vue?vue&type=script&lang=js"
export * from "./LastTransaction.vue?vue&type=script&lang=js"

import "./LastTransaction.vue?vue&type=style&index=0&id=1fe85b16&lang=scss"
import "./LastTransaction.vue?vue&type=style&index=1&id=1fe85b16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe85b16"]])

export default __exports__